import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Link } from 'react-router-dom';
import ThemeToggle from '../ThemeToggle';
import logoLight from '../../imgs/logo-light.png';
import logoDark from '../../imgs/logo-dark.png';

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const LogoImg = styled.img`
  height: 36px;
  width: auto;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  
  @media (max-width: 768px) {
    gap: 0.75rem;
  }
`;

const NavButton = styled(Link)`
  padding: 0.5rem 1.25rem;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  
  ${({ $primary, theme }) => $primary ? `
    background: ${theme.colors.activeColor};
    color: white;
    
    &:hover {
      background: ${theme.colors.activeColorDarkened};
    }
  ` : `
    color: ${theme.colors.cardText};
    background: transparent;
    
    &:hover {
      color: ${theme.colors.activeColor};
    }
  `}
`;

const LandingNav = ({ handleThemeChange }) => {
  const theme = useContext(ThemeContext);
  const logo = theme.name === 'dark-theme' ? logoLight : logoDark;

  return (
    <Nav>
      <LogoLink to="/">
        <LogoImg src={logo} alt="PropNinja" />
      </LogoLink>
      <NavLinks>
        <ThemeToggle onClick={handleThemeChange} />
        <NavButton to="/signin">Sign In</NavButton>
        <NavButton to="/signup" $primary>Get Started</NavButton>
      </NavLinks>
    </Nav>
  );
};

export default LandingNav;
